const getIsGlobalLoading = (state) => state.Session.isGlobalLoading;

export default getIsGlobalLoading;
